import React from "react";
import logo from "../images/ks-logo.png";
import QRCode from "../images/qr-code-img.png";
import NewImg from "../images/ks-new-logo.png";
const KS10Header = () => {
  return (
    <div className="header row">
      <div className="col-sm-12 col-md-4 col-lg-3 ">
        <div className="logo">
          <img src={logo} className="icd-logo" alt="logo" />
        </div>
      </div>
      <div className="col-sm-12 col-md-8 col-lg-6 qr-code">
        <div className="qr-code-img">
          <div className="qr-code-img">
            <img src={QRCode} className="qr-img" alt="logo" />
          </div>
        </div>
        <div className="qr-code-text">KS10 0420</div>
      </div>
      <div className="col-sm-12 col-md-12 col-lg-3 text-right ">
        <div className="id-date">
          KS10
          <span>April 2020</span>
        </div>

        <div className="new-logo-img">
          <img src={NewImg} className="new-logo" alt="logo" />
        </div>
      </div>
    </div>
  );
};

export default KS10Header;
